// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fees-for-stop-master-form .el-form--inline {\n  display: flex;\n}\n.fees-for-stop-master-form td .el-form-item {\n  margin-bottom: 5px !important;\n}\n.fees-for-stop-master-form td .el-form-item__content {\n  margin-left: 0% !important;\n}\n.fees-for-stop-master-form td .el-form-item.numeric .el-input-number {\n  width: 13em !important;\n}", ""]);
// Exports
module.exports = exports;
